import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getTranslation } from '@shared/translate-helper';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false,
})
export class NotFoundComponent {
  public errorCode: string = '404';
  public errorTitle!: string;
  public errorDescription!: string;
  public quickTip!: string;

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    getTranslation(this.translateService, ['404_title', '404_description', '404_quick_tip']).subscribe((t) => {
      this.errorTitle = t['404_title'];
      this.errorDescription = t['404_description'];
      this.quickTip = t['404_quick_tip'];
    });
  }
}
